import React from 'react'

const FeatureCard = ({data}) => {
  return (
    <div  className='w-full border-2 border-[#012f22] hover:border-[#22beff] rounded-2xl py-[50px] px-[15px] bg-[#133A50] flex flex-col gap-4 justify-center items-center transition-all duration-300 ease-linear '>
        <img src={data?.image} alt={data?.name} className='w-[4rem]' />
        <h2 className='text-2xl font-bold text-white text-center'>{data?.name}</h2>
    </div>
  )
}

export default FeatureCard